import React from 'react';
import { LayoutDashboard, Users, BarChart3, LogOut, Activity, FileText } from 'lucide-react'; // Import FileText icon
import { NavLink, useNavigate } from 'react-router-dom';
import Logo from '../../assets/images/vvslogo.jpeg';
import { setRegToken, setAdmindata } from '../../Redux/Action/Authaction';
import { useDispatch } from 'react-redux';

const Sidebar = () => {
  const menuItems = [
    { icon: LayoutDashboard, label: 'Dashboard', path: '/dashboard' },
    { icon: Users, label: 'Task', path: '/task' },
    { icon: BarChart3, label: 'Documents', path: '/documents' },
    { icon: Users, label: 'Employees', path: '/employee-listing' },
    { icon: Activity, label: 'Activity', path: '/employee-activity' },
    { icon: FileText, label: 'Report', path: '/employee-report' }, // Updated to use FileText icon
  ];

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleLogout = async () => {
    dispatch(setRegToken(''));
    dispatch(setAdmindata(''));
    navigate('/');
  };

  return (
    <div className="w-64 bg-white border-r border-gray-200 flex flex-col h-screen">
      <div className="p-6 m-auto">
        <img src={Logo} alt="Company Logo" className="h-10 w-10" />
      </div>

      <nav className="flex-1 px-4 overflow-y-auto">
        <ul className="space-y-1">
          {menuItems.map((item, index) => (
            <li key={index}>
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  `flex items-center px-4 py-3 text-sm rounded-lg ${
                    isActive
                      ? 'bg-blue-50 text-blue-600'
                      : 'text-gray-700 hover:bg-gray-100'
                  }`
                }
              >
                <item.icon className="h-5 w-5 mr-3" />
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      <div className="p-4 border-t border-gray-200">
        <button
          onClick={handleLogout}
          className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-gray-100 rounded-lg w-full"
        >
          <LogOut className="h-5 w-5 mr-3" />
          Logout
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
